export enum TireStatusesEnum {
	INTRANSIT = 'INTRANSIT',
	PENDING = 'PENDING',
	FULFILLED = 'FULFILLED',
	CANCEL = 'CANCEL',
	CANCEL_CD = 'CANCEL_CD',
	CANCEL_OT = 'CANCEL_OT',
	CANCEL_UA = 'CANCEL_UA',
	CANCEL_CR = 'CANCEL_CR',
}